module.exports = __webpack_public_path__ + "img/my_open_redpack_bg.925adc4b.png";